import React from 'react';
import PropTypes from 'prop-types';

import Form from '../../../../components/Form';
import Address from './address';

import messages from './messages';

const Contact = ({ onChange, initialValue, formatMessage }) => (
  <React.Fragment>
    <Form.Input
      fluid
      label={formatMessage(messages.namePrefix)}
      placeholder={formatMessage(messages.namePrefix)}
      value={initialValue.namePrefix?.value}
      data-cy="Premium-Hem-contactInformation-NamePrefix-Input"
      onChange={(e, { value }) => {
        onChange(e, { namePrefix: { ...initialValue.namePrefix, value } });
      }}
      maxLength="255"
    />
    <Form.Input
      fluid
      label={formatMessage(messages.firstName)}
      placeholder={formatMessage(messages.firstName)}
      value={initialValue.firstName?.value}
      data-cy="Premium-Hem-contactInformation-FirstName-Input"
      onChange={(e, { value }) => {
        onChange(e, { firstName: { ...initialValue.firstName, value } });
      }}
      maxLength="255"
    />
    <Form.Input
      fluid
      label={formatMessage(messages.middleName)}
      placeholder={formatMessage(messages.middleName)}
      value={initialValue.middleName?.value}
      data-cy="Premium-Hem-contactInformation-MiddleName-Input"
      onChange={(e, { value }) => {
        onChange(e, { middleName: { ...initialValue.middleName, value } });
      }}
      maxLength="255"
    />
    <Form.Input
      fluid
      label={formatMessage(messages.lastName)}
      placeholder={formatMessage(messages.lastName)}
      value={initialValue.lastName?.value}
      data-cy="Premium-Hem-contactInformation-LastName-Input"
      onChange={(e, { value }) => {
        onChange(e, { lastName: { ...initialValue.lastName, value } });
      }}
      maxLength="255"
    />
    <Form.Input
      fluid
      label={formatMessage(messages.jobDescription)}
      placeholder={formatMessage(messages.jobDescription)}
      value={initialValue.jobDescription?.value}
      data-cy="Premium-Hem-contactInformation-JobDescription-Input"
      onChange={(e, { value }) => {
        onChange(e, { jobDescription: { ...initialValue.jobDescription, value } });
      }}
      maxLength="255"
    />
    <Address onChange={onChange} initialValue={initialValue} formatMessage={formatMessage} />
  </React.Fragment>
);
Contact.propTypes = {
  initialValue: PropTypes.object,
  onChange: PropTypes.func,
  formatMessage: PropTypes.func,
};

export default Contact;
